import { setCookie, getCookie } from 'tiny-cookie'
import api from '@/lib/api'

const LICENSE_KEY = 'pt_license'

export default {
  current() {
    return getCookie(LICENSE_KEY)
  },
  set(value) {
    return setCookie(LICENSE_KEY, value, {
      expires: 365,
      domain: window.location.hostname,
      secure: window.location.protocol === 'https:'
    })
  },
  requireAuth(controller) {
    let license = this.current()

    if (license) {
      api.setLicense(license)
      return false
    }

    controller.$router.push({ path: `/login?to=${window.location.pathname}` })

    return true
  }
}
